module.exports = __webpack_public_path__ + "static/media/EMVideo_Icon.ad679ec0.png";